import React from 'react';

import './style.scss';

import ReactTooltip from 'react-tooltip';

const checkIcon = require('../../../assets/icons/check-icon.png');

const Results = (props) => {
  const {
    user,
    nationalTopics,
  } = props;
  const {
    national_stances: userNationalStances = {},
  } = user;

  const generateCandidatePosition = (baseValue, jiggle) => {
    const posVal = 47 + ((baseValue + (jiggle || 0)) * 47);
    const negVal = 47 + ((baseValue + ((jiggle || 0) * -1)) * 47);
    return posVal > 90 ? negVal : posVal;
  };

  return (
    <div>
      <div id="compare-candidate-container">
        <h1>Results</h1>
        <div className="candidate-natl-topic-container content-container">
          <div className="top-info-container">
            <h2> Your Stances on National Topics</h2>
          </div>
          <div className="candidate-stance-table-container">
            <div className="favor-score-header-container">
              <p>Strongly Against</p>
              <p>Against</p>
              <p>Neutral</p>
              <p>In Favor</p>
              <p>Strongly In Favor</p>
            </div>
            <table>
              <tbody>
                {nationalTopics.map((topic, idx) => (
                  <tr>
                    <td className="topic-stance" style={idx === nationalTopics.length - 1 ? { borderBottom: 0 } : {}}>{topic.description}</td>
                    <td className="topic-value" style={idx === nationalTopics.length - 1 ? { borderBottom: 0 } : {}}>
                      <div className="preview-parent">
                        {(userNationalStances[topic.title] !== undefined && userNationalStances[topic.title] !== null) ? (
                          <>
                            <img
                              alt="check icon"
                              className="candidate-preview-container"
                              data-tip="Where you rated yourself in our quiz"
                              src={checkIcon}
                              style={{ left: `${generateCandidatePosition(userNationalStances[topic.title], 0)}%` }}
                            />
                            <ReactTooltip />
                          </>
                        ) : null}
                        <ReactTooltip />
                      </div>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Results;
